export default __webpack_public_path__ + "static/5-be7cb89b9747a3f854768aee3f929a7a.jpg";